var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncreasedPerformance = function SvgIncreasedPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.318.808 15.168 20H5.335a.667.667 0 0 1-.542-1.059L18.125.274a.667.667 0 0 1 1.193.534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.015 12.097a.666.666 0 0 1 .196.956L13.878 31.72a.666.666 0 0 1-1.194-.533L16.834 12h9.834c.123 0 .242.034.347.097",
    opacity: 0.4
  })));
};
export default SvgIncreasedPerformance;